import c from '../constants/Constants';
import $ from 'jquery';

require('es6-promise').polyfill();
require('isomorphic-fetch');


var contactos = {

        getAll(filtros) {
            var esc = encodeURIComponent;
            var query = "";
            if (filtros)
                query = Object.keys(filtros)
                    .map(k => esc(k) + '=' + esc(filtros[k]))
                    .join('&');

            let defaultOptions = {
                url: '',
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Content-Type": "application/json;charset=UTF-8",
                    
                },
                // cache: false,
                dataType: 'json',
            };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
            return fetch(c.BASE_URL + '/contactos/?' + query, defaultOptions);
        },
        getOne(idContacto) {
            let defaultOptions = {
                url: '',
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Content-Type": "application/json;charset=UTF-8",
                    
                },
                // cache: false,
                dataType: 'json',
            };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
            return fetch(c.BASE_URL + '/contactos/' + idContacto, defaultOptions);
        },

        saveCreate(nuevo, files) {
    var formData = new FormData();
    if (files) {
        files.forEach((file) => {
            if(file)
                formData.append(file.name, file);
        });
    }
    formData.append("contacto", JSON.stringify(nuevo));
    return $.ajax({
        url: c.BASE_URL + '/contactos/',
        //dataType: 'json',
        data: formData,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('authorization', "Bearer " + localStorage.token);
            
        },
        contentType: false,
        type: 'POST',
        processData: false,
        enctype: 'multipart/form-data',
    });

},
        saveUpdate(activo, files) {
    var formData = new FormData();
    if (files) {
        files.forEach((file) => {
            if(file)
                formData.append(file.name, file);
        });
    }

    formData.append("contacto", JSON.stringify(activo));
    return $.ajax({
        url: c.BASE_URL + '/contactos/' + activo.id,
        //dataType: 'json',
        data: formData,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('authorization', "Bearer " + localStorage.token);
            
        },
        contentType: false,
        type: 'POST',
        processData: false,
        enctype: 'multipart/form-data',
    });
},
          saveUpdateContactos(activos) {
                 let defaultOptions = {
                     url: '',
                     method: 'PUT',
                     mode: 'cors',
                     headers: {
                         'Access-Control-Allow-Origin': '*',
                         "Content-Type": "application/json;charset=UTF-8",
                         "Authorization": "Bearer " + localStorage.token,
                         
                     },
                     // cache: false,
                     dataType: 'json',
                     body: JSON.stringify(activos)
                 };
            if (!!localStorage.token) {
               defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
                 return fetch(c.BASE_URL + '/contactos/all', defaultOptions);
             },
             saveDelete(contacto) {
                     let defaultOptions = {
                         url: '',
                         method: 'DELETE',
                         mode: 'cors',
                         headers: {
                             'Access-Control-Allow-Origin': '*',
                             "Content-Type": "application/json;charset=UTF-8",
                             "Authorization": "Bearer " + localStorage.token,
                             
                         },
                         // cache: false,
                         dataType: 'json',
                     };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
                     return fetch(c.BASE_URL + '/contactos/' + contacto.id, defaultOptions);
                 },
         saveCreateContactos(nuevos) {
              let defaultOptions = {
                  url: '',
                  method: 'POST',
                  mode: 'cors',
                  headers: {
                      'Access-Control-Allow-Origin': '*',
                      "Content-Type": "application/json;charset=UTF-8",
                      "Authorization": "Bearer " + localStorage.token,
                      
                  },
                  // cache: false,
                  dataType: 'json',
                  body: JSON.stringify(nuevos)
              };
             if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
             }
                  return fetch(c.BASE_URL + '/contactos/all', defaultOptions);
              },
         printContacto(idContacto) {
                 let defaultOptions = {
                     url: '',
                     method: 'GET',
                     mode: 'cors',
                     headers: {
                         'Access-Control-Allow-Origin': '*',
                         "Content-Type": "multipart/form-data",
                         "Authorization": "Bearer " + localStorage.token,
                         
                     },
                     cache: "no-cache"
                 };
                 return fetch(c.BASE_URL + '/contactos/' + idContacto + "/edit/", defaultOptions);
             },
    };

export default contactos;